import Box from '@material-ui/core/Box'
import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import { Theme } from '@material-ui/core/styles/createTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import Close from '@material-ui/icons/Close'
import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'

import colorContext from '../../Context/colorContext'
import { PropsIconsHeader, PropsLinksHeader } from '../Header'
import PlayerComponent from '../PlayerComponent'

interface DrawerProps {
  isOpen: boolean
  handleOpenDrawerQuickAccess: () => void
  links: PropsLinksHeader[]
  icons: PropsIconsHeader[]
}

const QuickAccessDrawer = ({
  isOpen,
  handleOpenDrawerQuickAccess,
  links,
  icons,
}: DrawerProps): JSX.Element => {
  const [isPlaying, setIsPlaying] = useState(false)
  const { colors, setTypeTheme, typeTheme } = useContext(colorContext)
  const useStyles = makeStyles((theme: Theme) => ({
    drawerActions: {
      top: 224,
      height: 'calc(100vh - 126px)',
      backgroundColor: colors.colorBackgroundSecundary,
      overflow: 'auto',
    },
    titleDrawer: {
      margin: '24px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    textDrawer: {
      fontFamily: 'Roboto',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 700,
      textTransform: 'uppercase',
    },
    textLink: {
      textDecoration: 'none',
      fontFamily: 'Roboto',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 400,
      color: colors.textAccentColor,
      textTransform: 'uppercase',
      position: 'relative',
      cursor: 'pointer',
      '&::after': {
        content: '""',
        display: 'block',
        width: 1,
        height: 14,
        backgroundColor: colors.accentColor,
        position: 'absolute',
        bottom: 2,
        marginLeft: -14,
        left: 5,
      },
    },
    info: {
      padding: '56px 0px',
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
    },
    titleSocial: {
      fontFamily: 'Roboto',
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 400,
      textTransform: 'uppercase',
      textAlign: 'center',
    },
    boxLinks: {
      padding: '15px 20px',
      borderBottom: '1px solid rgba(177, 188, 223, 0.56)',
    },
    socials: {
      justifyContent: 'center',
      display: 'flex',
    },
    titleRadio: {
      fontFamily: 'Roboto',
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 400,
      textTransform: 'uppercase',
      margin: '16px 0px',
    },
    boxRadio: {
      width: '100%',
      height: 28,
      borderRadius: 10,
      backgroundColor: colors.colorBackgroundSecundary,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 40,
    },
    buttonPlay: {
      width: 40,
      height: 28,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#442771',
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10,
      padding: 11,
      cursor: 'pointer',
    },
    textTitleRadio: {
      fontSize: theme.typography.pxToRem(8),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '0.9',
      textAlign: 'center',
      textTransform: 'uppercase',
    },
    textSubTitleRadio: {
      fontSize: theme.typography.pxToRem(10),
      fontStyle: 'normal',
      fontWeight: 400,
      textAlign: 'center',
      textTransform: 'uppercase',
    },
  }))
  const classes = useStyles()

  const handlePlayer = () => setIsPlaying(!isPlaying)

  const handleClose = () => {
    handleOpenDrawerQuickAccess()
  }

  function handleSwitchColor() {
    setTypeTheme(typeTheme === 'normal' ? 'contraste' : 'normal')
  }

  return (
    <Drawer anchor="bottom" open={isOpen} onClose={handleClose}>
      <Box className={classes.drawerActions}>
        <Box className={classes.titleDrawer}>
          <Typography className={classes.textDrawer}>Acesso rápido</Typography>
          <IconButton onClick={handleOpenDrawerQuickAccess}>
            <Close style={{ fontSize: 30, color: 'white' }} />
          </IconButton>
        </Box>
        <Box>
          {links?.length &&
            links.map((link) => (
              <div key={`${link.titulo}-key`} className={classes.boxLinks}>
                <a
                  href={link.url}
                  target={link.link_externo ? '_blank' : '_parent'}
                  className={classes.textLink}
                  rel="noreferrer"
                >
                  {link.titulo}
                </a>
              </div>
            ))}
          <div className={classes.boxLinks}>
            <Link
              to="/acessibilidade"
              onClick={() => handleClose()}
              className={classes.textLink}
            >
              Acessibilidade
            </Link>
          </div>
          <div className={classes.boxLinks}>
            <Box
              onClick={() => {
                handleSwitchColor()
                handleClose()
              }}
              className={classes.textLink}
            >
              Contraste
            </Box>
          </div>
        </Box>
        <Box className={classes.info}>
          <Typography className={classes.titleRadio}>Nossa rádio</Typography>
          <Box className={classes.boxRadio} onClick={() => handlePlayer()}>
            <PlayerComponent handlePlay={handlePlayer} isPlaying={isPlaying} />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '3px 8px',
              }}
            >
              <Typography className={classes.textTitleRadio}>
                OUÇA AO VIVO - A RÁDIO DO RIO - 94 FM
              </Typography>
              <Typography className={classes.textSubTitleRadio}>
                RÁDIO ROQUETTE PINTO
              </Typography>
            </div>
          </Box>
          <div>
            <Typography className={classes.titleSocial}>
              Siga-nos nas redes sociais
            </Typography>
            {icons && (
              <Box className={classes.socials}>
                {icons.map((icon) => (
                  <IconButton
                    key={`${icon.titulo}-key`}
                    href={icon.url}
                    target="_blank"
                    aria-label={`${icon.titulo} (abre em nova aba)`}
                  >
                    <img
                      width="25px"
                      height="25px"
                      src={icon.url_imagem}
                      alt=""
                      loading="lazy"
                    />
                  </IconButton>
                ))}
              </Box>
            )}
          </div>
        </Box>
      </Box>
    </Drawer>
  )
}

export default QuickAccessDrawer
